
import VueI18n from "vue-i18n";
import Vue from "vue";
const navLang = process.env.VUE_APP_CUSTOMER === 'jzz' ? (navigator.language.includes("zh") ? "zh": "en") : 'en' //navigator.language || navigator.userLanguage || "en-US";


Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: navLang, // 语言标识
  messages: process.env.VUE_APP_CUSTOMER === 'jzz' ? {
    en: require("../config/languages/en-US.json"),
    // enUS: require("./config/languages/en-US.json"),
    // th: require("./config/languages/th-TH.json"),
    zh: require("../config/languages/zh-CN.json"),
    // "th-TH": require("./config/languages/th-TH.json"),
    // "en-US": require("./config/languages/en-US.json"),
    // "zh-CN": require("./config/languages/zh-CN.json"),
  }: {
    en: require("../config/languages/en-US.json"),
    zh: require("../config/languages/zh-CN.json"),
  }
});

export default i18n